import { PresentationApiClient } from "./presentation";
import { ProposalApiClient } from "./proposals";

export default {
  presentation: new PresentationApiClient(),
  proposals: new ProposalApiClient(),
};
